export default __webpack_public_path__ + "static/wolfire-games-logo-81bd6bf11800356db9f73548801cce12.png";